// extracted by mini-css-extract-plugin
export default {"login_user":"Dashboard_login_user__cjO8t"};